import HBIcon from "@/components/HBIcon";
import LetterNav from "@/components/TagManager/letterNav";
import UserTag from "@/components/UserTag";
import { getTags } from "@/services";
import { useSafeState } from "ahooks";
import classNames from "classnames";
import { useCallback, useEffect, useRef } from "react";
import { When } from "react-if";
import groupRecordsByPinyin from "../../../utils/groupRecordsByPinyin";
import tagManagerStyles from "../../TagManager/index.module.less";
import styles from "../index.module.less";
import Empty from "./Empty";
import Loading from "./Loading";

export default function UserTags({ urlname, isMe, limit, initTags }) {
  limit = limit ?? 10;
  const [loading, setLoading] = useSafeState(!initTags);
  const [groupsToRender, setGroupsToRender] = useSafeState(initTags || []);
  const tagRef = useRef(null);

  const init = useCallback(async () => {
    setLoading(true);
    const { tags, recent, err } = await getTags({
      urlname,
      limit,
      ...(isMe ? { sort: "often" } : null),
    });
    setLoading(false);

    if (err) return;

    const result = (
      await groupRecordsByPinyin(tags, (record) => record.tag_name)
    ).map(([title, records]) => ({
      title,
      records,
    }));

    if (isMe) {
      result.unshift({
        icon: "ic_schedule2",
        title: "常用标签",
        records: recent || [],
      });
    }

    setGroupsToRender(result);
  }, [limit, setGroupsToRender, setLoading, isMe, urlname]);

  const onRefresh = useCallback(() => {
    init();
  }, [init]);

  useEffect(() => {
    !initTags && init();
  }, [init, initTags]);

  if (loading) {
    return <Loading />;
  }

  return (
    <div className={styles.tagsPanel} ref={tagRef}>
      {groupsToRender.length ? (
        groupsToRender.map(({ title, icon, records }, index) => (
          <div
            className={classNames([tagManagerStyles.group, `letter-${index}`])}
            key={title}
          >
            <div className={tagManagerStyles.title}>
              <When condition={icon}>
                <HBIcon className={tagManagerStyles.icon} type={icon} />
              </When>
              <span>{title.toUpperCase()}</span>
            </div>
            {records.map((record, idx) => (
              <UserTag
                key={`${record.tag_name}_${idx}`}
                record={record}
                urlname={urlname}
                isMe={isMe}
                onDelete={onRefresh}
                onRename={onRefresh}
                link={`/space/tags/${encodeURIComponent(record.tag_name)}`}
              />
            ))}
          </div>
        ))
      ) : (
        <Empty
          imageUrl={
            "https://cdn.dancf.com/fe-assets/img/05a97a9728a7561f80b5e430acfc94b9.png"
          }
          title={"还没有标签哦～"}
        />
      )}
      <LetterNav container={tagRef.current} list={groupsToRender} />
    </div>
  );
}
